import script from "./TreatmentPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./TreatmentPlan.vue?vue&type=script&setup=true&lang=js"

import "./TreatmentPlan.vue?vue&type=style&index=0&id=4a685a8a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a685a8a"]])

export default __exports__